var cart = require('../cart/cart');

var updateMiniCart = true;
var location = window.location;
let hoverTimeout;

module.exports = function () {
    cart();
    /**
    * Validate screen
    *
    */
    function checkScreenWidth() {
        if ($(window).width() < 1200) {
            $('.popover').removeClass('show');
            $('.background-overlay').addClass('d-none');
            $('body').removeClass('no-scroll');
        }
    }
    /**
    * upgrade mini cart information
    *
    */
    function reloadMiniCart() {
        var url = $('.minicart').data('action-url');
        $('.minicart .popover').addClass('show').spinner().start();
        $.get(url, function (data) {
            $('.minicart .popover').empty().append(data);
            updateMiniCart = false;
            $('.minicart .popover').spinner().stop();
        });
    }

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.cart.items.length);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });

            // Show or hide quantity number in minicart icon
            if (count.quantityTotal>0){
                $(".minicart-quantity").removeClass("d-none");       
            } else {
                $(".minicart-quantity").addClass("d-none");
            }

        }
    });

    $('.minicart').on('mouseenter focusin touchstart', function () {
        if ($('.search:visible').length === 0) {
            return;
        }

        hoverTimeout = setTimeout(() => {
            var url = $('.minicart').data('action-url');
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);
            var modal = $('.minicart .popover');


            $('#embeddedMessagingConversationButton').addClass('d-none');

            if (count !== 0 && $('.minicart .popover.show').length === 0) {
                $('.background-overlay').removeClass('d-none');
                if (!updateMiniCart) {
                    modal.animate({ right: '-1' }, 400);
                    $('.minicart .popover').addClass('show');
                    $('body').addClass('no-scroll');
                    return;
                }

                modal.animate({ right: '-1' }, 400);
                modal.addClass('show');

                $('.minicart .popover').spinner().start();
                $('body').addClass('no-scroll');

                $.get(url, function (data) {
                    $('.minicart .popover').empty();
                    $('.minicart .popover').append(data);
                    updateMiniCart = false;
                    $.spinner().stop();
                });
            }
        }, 200);
    });

    $('.minicart').on('mouseleave focusout touchend', function () {
        clearTimeout(hoverTimeout);
    });
    $(document).on('click', function(event) {
        if (!$(event.target).closest('.popover, .minicart').length) {
            $('#embeddedMessagingConversationButton').removeClass('d-none');
            $('.popover').removeClass('show');
            $('.background-overlay').addClass('d-none');
            $('.minicart .popover').removeAttr("style");
            $('body').removeClass('no-scroll');
        }
    });
    $(document).on('click', '.close-minicart', function (e) {

        $('#embeddedMessagingConversationButton').removeClass('d-none');

        var modal = $('.minicart .popover');
        modal.removeClass('show');
        $('.background-overlay').addClass('d-none');
        $('body').removeClass('no-scroll');
        modal.removeAttr("style");
    });
    $(document).on('click', '.remove-btn', function (event) {
        reloadMiniCart();
    });
    $(document).on('click', '.empty-cart', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        $('.minicart-quantity').first().text(0);
        const isMiniCart = $(event.target).closest('.minicart');
        if (isMiniCart.length) {
            isMiniCart.find('.confirmation-empty-cart').show("normal");
            $(".mini-cart-overlay").show();
        } else if ($('.cart-page').length) {
            $('#confirmation-empty-cart-modal').addClass('slide-from-bottom').modal("show");
        }
    });
    $(document).on('click', '.cancel-empty-cart', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const isMiniCart = $(event.target).closest('.minicart');
        if (isMiniCart.length) {
            isMiniCart.find('.confirmation-empty-cart').hide("normal");
            $(".mini-cart-overlay").hide();
        } else if ($('.cart-page').length) {
            $('#confirmation-empty-cart-modal').modal("hide");
        }
    });
    $(document).on('click', '.confirm-empty-cart', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        $.spinner().start();
        var url = $('.empty-cart').attr('href');

        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            success: function (data) {
                if (data.searchImpressionData) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(JSON.parse(data.searchImpressionData));
                }
                reloadMiniCart();
                $('.container-mini-cart-clear').removeClass('d-none');
                $(".minicart-quantity").addClass("d-none");
                if ($('.cart-page').length) {
                    location.reload();
                }
                $('#confirmation-empty-cart-modal').modal("hide");
            },
            error: function (err) {
                $.spinner().stop();
            },
            complete: function () {
                $.spinner().stop();
            }
        });
    });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });
    
    // Check screen width on page load and window resize
    checkScreenWidth();
    $(window).on('resize', checkScreenWidth);
};
